export const FIELD_MAPPINGS = {
  period: 'periodName',
  fromcurrency: 'fromCurrency',
  tocurrency: 'toCurrency',
  openspotrate: 'openSpotRate',
  endspotrate: 'endSpotRate',
  monthlyoperatingrate: 'monthlyOperatingRate',
  weightedaveragerate: 'weightedAverageRate',
  fromcurrencyprecision: 'fromCurrencyPrecision',
  tocurrencyprecision: 'toCurrencyPrecision',
};
export const MIN_COLUMNS_NUMBER = 9;
export const MAX_COLUMNS_NUMBER = 9;
